var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default", null, { show: _vm.show, hide: _vm.hide }),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "popup",
          attrs: { size: "large" },
          on: {
            hidden: function($event) {
              return _vm.resetInitialTab()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "modal-body" },
            [
              _c("touchpoint-overview", {
                attrs: {
                  "brick-id": _vm.brickId,
                  name: _vm.brickName,
                  type: _vm.brickType,
                  config: _vm.brickConfig,
                  "disable-statistics": _vm.brickIsNew,
                  "incoming-connections-info": _vm.IncomingConnectionsInfo,
                  "outgoing-connections-info": _vm.OutgoingConnectionsInfo,
                  "initial-tab": _vm.initialTab
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "modal-footer" }, [
            _c("div", { staticClass: "row justify-content-end" }, [
              _c("div", { staticClass: "col-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-lg",
                    on: { click: _vm.hide }
                  },
                  [
                    _c("i", { staticClass: "fas fa-check-circle" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.resource("Button_OK")) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }